<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/66/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/66/title-1.png" alt="" />
                    <div class="content" style="font-weight: bold;padding:0.42rem 0.61rem;">
                    急需紧缺人才和高端人才、青年大学生等。
                    </div>
                </div>
                <div class="fund">
                    <img class="top" src="./../assets/imgs/66/title-2.png" alt="" />
                    <div class="content">
                        <div class="text">
                            （一）给予急需紧缺人才和高端人才创新创业扶持。对携带重大科技成果、重大产业化项目来我市创新创业的，按照A类、B类、C类人才或其领衔的创新创业团队（企业），分别给予该团队（企业）最高300万元、200万元、120万元项目启动资金。所携带项目对促进我市主导产业发展有重大作用、具有良好发展前景、能够产生重大经济社会效益的，经行业主管部门组织第三方专业机构评审认定，可采取“一人一策”“一企一策”等方式，按照A类、B类、C类人才或其领衔的创新创业团队，分别给予最高1亿元、3000万元、1000万元的综合资助。
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （二）对企业新引的各类人才，给予最长5年生活补助。其中，对新引进且签订1年以上劳动合同的A类、B类、C类人才，分别给予10000元/月、8000元/月、5000元/月生活补助；对新引进且签订3年以上劳动合同的D类（不含硕士研究生）人才，给予3500元/月生活补助；对新引进且签订5年以上劳动合同的E类人才、副高级专业技术人才，给予2500元/月生活补助；对新引进且签订5年以上劳动合同的取得硕士研究生学历且获得相应学位的国内外高校毕业生（国外高校取得的学历及学位必须经国家教育主管部门认证通过），给予1500元/月生活补助。若同一人才同时具备本条中2项及以上条件的，按从高不重复的原则享受补助
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （三）加强急需紧缺人才和高端人才培养。对通过我市新申报获评各级“人才计划”、学术与技术带头人、工艺美术大师、非物质文化遗产传承人以及获得各级自然科学、社会科学、技术发明、科技进步奖、发展卓越人才奖的个人或项目，且在我市未享受过同一级别配套奖励的，按照上级奖励资金的100%给予一次性配套奖励，其个人或项目主要完成人享受本行动计划中新引进人才相关政策。对通过我市新申报入围各类“人才计划”答辩环节的个人或团队，按照国家级、省级、成都市级分别给予20万元、10万元、5万元一次性奖励。
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （四）支持人才提升学历和能力。对在职新取得博士、硕士研究生学历且获得相应学位的个人，分别给予3万元、1万元一次性补助。对在职新取得正高级、副高级专业技术职务任职资格的个人，分别给予1万元、5000元一次性补助。
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （五）为急需紧缺人才和高端人才提供人才公寓租赁服务。A类人才，可根据人才本人愿望，在崇州市区域内自由选择人才公寓任一户型住房免费入住，在崇州工作服务满5年可免费（含个人所得税）获得该住房所有权；B类人才，可根据人才本人愿望，在崇州市区域内自由选择人才公寓任一户型住房免费入住，在崇州工作服务满5年可按入住时市场价格的50%购买，购房后5年内不得出售；C类、D类、E类人才，在崇州市无自有住房的，可根据人才类别提供人才公寓供其租住5年，租金以不高于当年市场价格的60%计算，租住满5年后可申请按入住时的市场价格购买，购房后5年内不得出售。夫妻双方均符合条件的，按“就高不重复”原则执行。
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （六）对新引进未入住人才公寓且在崇州市无自有住房的急需紧缺人才和高端人才，给予最长5年的租房补贴。A类人才补贴5000元/月，B类人才补贴3000元/月，C类人才补贴2000元/月，D类人才补贴1000元/月，E类人才补贴500元/月。租房补贴在每年12月一次性发放。
                        </div>
                        <div class="text" style="margin-top: 0.2rem">
                            （七）对新引进的首次购买崇州市范围内住房的急需紧缺人才和高端人才，可在其购房款额度内给予一次性购房补贴。A类人才最高补贴100万元，B类人才最高补贴60万元，C类人才最高补贴40万元。夫妻双方均符合条件的，按“就高不重复”原则执行。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/26/title-3.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报</div>
                                </div>
                                <div class="line-content">
                                    由申报人填写相关资料，其本人或委托代理人向“崇州市人才综合服务窗口”（市人社局一楼大厅，崇州市永康东路385号，人才服务专线82293012）进行申报。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">核准</div>
                                </div>
                                <div class="line-content">
                                    由市人社局对申报人所申报事项是否符合、申报资料是否真实齐备等进行审核，并会同相关部门联审后提交市委人才办。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">审定</div>
                                </div>
                                <div class="line-content">
                                    由市委人才办提交市人才工作领导小组会议审定，审定后由市人才办会同市财政局、市人社局及时兑现补贴。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sxcl" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/66/title-4.png" alt="" />
                    <div class="content" style="font-weight: bold; text-align: center">
                        每年申报1-2次，依据具体通知时间确定。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">中共崇州市委组织部人才工作科</span>
                            <div>
                                <a href="tel:028-85511053">028-82228953</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">市人社局 </span>
                            <div>
                                <a href="tel:028-82272297">028-82272297</a>
                            </div>
                        </div>
                        <!-- <div>
                                        政策咨询电话：
                                        <a href="tel:028-86259119">028-86259119</a>
                                    </div>
                                    <div>责任单位：中共成都市青羊区委组织部人才科</div> -->
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/66/code.png" />
                    <img class="text" src="../assets/imgs/66/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .contact {
        position: relative;
        margin-top: 0.22rem;

        .top {
            width: 7.03rem;
            height: 1.37rem;
            margin-left: -0.18rem;
        }

        .content {
            width: 6.85rem;
            background: #ffffff;
            margin: -0.45rem auto 0;
            padding: 0.33rem;
            padding-right: 0.1rem;
            box-sizing: border-box;
            border-radius: 0rem 0rem 0.26rem 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.3rem;
            font-weight: bold;
            text-align: left;
            color: #4e4e4e;

            .number {
                box-sizing: border-box;
                padding-left: 4.3rem;
                position: relative;
                line-height: 0.44rem;

            }

            .unit {
                margin-top: 0.15rem;
                box-sizing: border-box;
                padding-left: 1.5rem;
                position: relative;
                line-height: 0.44rem;

            }

            .label {
                position: absolute;
                left: 0;
                top: 0;
            }
        }
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;
                text-align: left;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                line-height: 0.44rem;

                color: #4e4e4e;
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .fund {
            position: relative;
            margin-top: 0.25rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                text-align: left;
                color: #4e4e4e;

                .text {
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 0.42rem 0.25rem;
                    font-size: 0.26rem;
                    border-radius: 0.26rem;
                    color: #4e4e4e;
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
